<h2>{{ 'orders.overlays.changedOverlay.changeRemark' | translate }}</h2>

<div style="padding: 8px">{{ 'orders.overlays.changedOverlay.newRetrievalDocument' | translate }}</div>

<div style="padding: 8px">{{ change.docName }}
  <button mat-button color="primary" (click)="downloadDocument(change.docId)">
    <mat-icon>download</mat-icon>
  </button>
</div>

<div style="padding: 8px">
  <button mat-button color="primary"
          (click)="accept()">{{ 'orders.overlays.changedOverlay.confirm' | translate }}
  </button>
  <button mat-button color="primary" (click)="cancel()">{{ 'orders.overlays.changedOverlay.cancel' | translate }}
  </button>
</div>
